import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const { t } = useTranslation();
  const latest = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
              <i className="ri-timer-line text-secondary-500 mr-2"></i>
              {t('home.latest_title')}
            </h2>
            <p className="text-sm text-foreground-600">{t('home.latest_subtitle')}</p>
          </div>
          <Link
            to="/category/rexue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('home.view_all')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 最新更新`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <span className="text-white text-xs font-medium">
                    更新至 {comic.chapters}{t('home.chapter')}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-secondary-500 text-background-50 text-[10px] rounded-full font-medium">
                    {comic.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.updatedAt} 更新</p>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            {t('home.view_all')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}